
import React, { useState, useEffect } from 'react';
import { TextField, ThemeProvider, createTheme, styled } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0094AD',
    },
  },
});

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    textTransform: 'uppercase',
    fontWeight: 'bolder',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'gray',
  },
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  fontSize: '15px',
}));

const InputBox = ({
  inputText = '',
  inputBoxName,
  handleChangeCustom,
  placeholder,
  textLength = 255,
  validate = false,
  isUppercase = false,
  isNumber = false,
  disableEvent = false,
  error = false,
  disabled = false,
  errorText = '',
   blockSpecialChar = true, // 🆕 new prop
}) => {
  const [value, setValue] = useState(inputText);

  useEffect(() => {
    setValue(inputText);
  }, [inputText]);

  const handleChange = (event) => {
    if (disableEvent) return;

    let val = event.target.value;

    if (isNumber && isNaN(Number(val))) return;
    if (validate && val.length > textLength) return;

    if (isUppercase) val = val.toUpperCase();

    handleChangeCustom(inputBoxName, val);
    setValue(val);
  };

  return (
    <ThemeProvider theme={theme}>
      <StyledTextField
        fullWidth
        error={error}
        helperText={errorText}
        label={value === '' ? placeholder : placeholder.toUpperCase()}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        variant="standard"
        margin="normal"
            onKeyDown={(e) => {
          if (blockSpecialChar) {
            const key = e.key;
            if (!/^[a-zA-Z0-9 ]$/.test(key) && key.length === 1) {
              e.preventDefault(); // Block special characters
            }
          }
        }}
      />
    </ThemeProvider>
  );
};

export default InputBox;

